// import react and gatsby libs
import React from 'react'

// import css libs
import styled from 'styled-components'
import media from 'styled-media-query'

// styled BannerImage element
const BannerImage = styled.div`

  img {
    width: 100%;
  }

  ${media.greaterThan("small")`
    /* screen width is greater than 450px (small) */

  `}

  ${media.greaterThan("medium")`
    /* screen width is greater than 768px (large) */

  `}
`

// export BannerImage component
export default ({ image, alt }) => {

  // catch empty image
  if ( !image ) return <div />

  return (
    <BannerImage>
      <img
        src={image}
        alt={alt} />
    </BannerImage>
  )
}
